import React from "react";
import {
    CartesianGrid,
    Line,
    LineChart,
    ReferenceLine,
    ResponsiveContainer,
    Tooltip,
    YAxis,
} from "recharts";
import { format } from "date-fns";
import { Stack } from "@mui/material";
import styled from "styled-components";

const TooltipContainer = styled.div`
    background-color: ${({ theme }) => theme.palette.background.tooltip};
    padding: 0.5rem;
    min-width: 10rem;
    align-items: center;
    flex-direction: column;
    border-radius: 6px;
`;

const TooltipTitle = styled.p`
    margin-top: 0;
    margin-bottom: 0.5rem;
`;

const TooltipContent = styled.p`
    font-size: 12px;
    margin: 0;
    color: ${({ color }) => color};
`;

const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
        return (
            <TooltipContainer role="status" aria-live="assertive">
                <TooltipTitle>
                    {`${format(new Date(payload[0].payload.datetime), "EEE d MMM yyyy")}`}
                </TooltipTitle>
                {payload.map((entry) => (
                    <Stack direction="row" spacing={0.5}>
                        <TooltipContent color={entry.color}>{entry.name} :</TooltipContent>
                        <TooltipContent>{entry.value.toFixed(2)}</TooltipContent>
                    </Stack>
                ))}
            </TooltipContainer>
        );
    }
    return null;
};

const CaseAnalysisTimeseries = ({ data }) => {
    return (
        <ResponsiveContainer width="99%" height="99%">
            <LineChart
                accessibilityLayer
                width={500}
                height={300}
                data={data}
                margin={{
                    top: 20,
                    right: 50,
                    left: 20,
                    bottom: 5,
                }}
            >
                <CartesianGrid strokeDasharray="3 3" style={{ opacity: 0.3 }} />
                <YAxis />
                <Tooltip cursor={{ opacity: "0.2" }} content={CustomTooltip} />
                <ReferenceLine y={0.2} stroke="#b61a23" />
                <ReferenceLine y={-0.2} stroke="#b61a23" />
                <Line
                    type="monotone"
                    dataKey="correlation"
                    stroke="#82ca9d"
                    activeDot={{ r: 6 }}
                    dot={{ r: 0 }}
                />
            </LineChart>
        </ResponsiveContainer>
    );
};
export default CaseAnalysisTimeseries;
